import {
  AspectRatio,
  GridView as GridViewIcon,
  Lock as LockIcon,
} from '@mui/icons-material';
import {
  CardContainer,
  CardInfoTitle,
  CardText,
  ChipContainer,
} from 'src/components/cardGrid';
import { DynamicTooltipChip } from 'src/components/dynamicTooltipChip/DynamicTooltipChip';
import { GenericCard } from 'src/components/genericCard';
import { CustomTooltip } from 'src/components/tooltip/CustomTooltip';
import { IStatus } from 'src/interfaces';
import { getExpiryStatusMessage, lang, showSoftSellComponent } from 'src/utils';

import { ComponentListCardProps } from './ComponentListCard.interface';

export const ComponentListCard = (props: ComponentListCardProps) => {
  const { component, selectedComponentId, onSelectedComponent } = props;
  const expiryStatusLabel = getExpiryStatusMessage(component?.end_date);

  return (
    <GenericCard
      isSelected={selectedComponentId === component.id}
      onClick={() => onSelectedComponent(component)}
      cardMedia={
        <ChipContainer>
          {component.status === IStatus.READY && <LockIcon />}
          {expiryStatusLabel && (
            <DynamicTooltipChip
              chipName={expiryStatusLabel}
              color="error"
              variant="outlined"
              size="small"
            />
          )}
          {showSoftSellComponent(component) && (
            <DynamicTooltipChip
              chipName={lang.softSell}
              color="info"
              variant="outlined"
              size="small"
            />
          )}
        </ChipContainer>
      }
      additionalContent={
        <>
          <CustomTooltip
            width={500}
            placement="bottom"
            title={component.name}
            overflowLineNumber={2}>
            <CardInfoTitle>{component.name}</CardInfoTitle>
          </CustomTooltip>
          {component.component_type && (
            <CardContainer>
              <GridViewIcon />
              <CardText>{component.component_type.name}</CardText>
            </CardContainer>
          )}
          <CardContainer>
            <AspectRatio />
            <CardText>{`${component.width}x${component.height}`}</CardText>
          </CardContainer>
        </>
      }
    />
  );
};
